import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_c2f4660c";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_c2f4660c" };
/** script content **/
require("./date-picker.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexc2f4660c%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fdate-picker%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_c2f4660c"],
    ctorType: "component",
    outputPath: "components/indexc2f4660c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker': getComponent(require("../picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
